import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ExecucaoSeguraService {
  
  constructor(private toastr: ToastrService) {}

  /**
   * Executa um método de forma segura, capturando erros e exibindo notificações
   * @param fn Função a ser executada
   * @param args Argumentos para a função
   * @param mensagemErro Mensagem de erro personalizada (opcional)
   * @returns Promise com o resultado da função ou undefined em caso de erro
   */
  public async executar<T = any>(
    fn: (...args: any[]) => T | Promise<T>,
    args: any[] = [],
    mensagemErro?: string
  ): Promise<T | undefined> {
    try {
      const resultado = fn.apply(this, args);
      
      if (resultado instanceof Promise) {
        return await resultado;
      }
      
      return resultado as T;
    } catch (e: any) {
      const mensagem = mensagemErro || `Falha ao executar o método: ${fn.name || 'desconhecido'}`;
      this.toastr.warning(mensagem);
      console.error(`Erro ao executar ${fn.name}:`, e);
      return undefined;
    }
  }

  /**
   * Versão síncrona do método executar
   */
  public executarSync<T = any>(
    fn: (...args: any[]) => T,
    args: any[] = [],
    mensagemErro?: string
  ): T | undefined {
    try {
      return fn.apply(this, args);
    } catch (e: any) {
      const mensagem = mensagemErro || `Falha ao executar o método: ${fn.name || 'desconhecido'}`;
      this.toastr.warning(mensagem);
      console.error(`Erro ao executar ${fn.name}:`, e);
      return undefined;
    }
  }
}
